import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-secondary-button",
  template: `
    <button (click)="pressed.emit()">
      {{ label }}
    </button>
  `,
  styles: [
    `
      button {
        border: none;
        background: #fff2e8;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 8px 16px;
        font-family: Karla;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 16px;
        text-align: center;
        color: #fc7c1b;
      }
    `,
    `
      button:focus {
        outline: none !important;
      }
    `,
    `
      button:hover {
        background: #fed8bb;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.23);
      }
    `,
    `
      button:active {
        background: #fdbd8d;
        color: #7e3e0d;
      }
    `,
    `
      button.large {
        background: #b05713;
        flex: 1 0 100%;
      }
    `,
    `
      button.small {
        font-size: 12px;
        line-height: 12px;
      }
    `,
    `
      .icon {
        background: #b05713;
        box-shadow: 0px 2px 4px transparent;
        font-size: 12px;
        line-height: 12px;
      }
    `
  ]
})
export class SecondaryButtonComponent implements OnInit {
  @Input() label: string = "rest";
  constructor() {}
  @Output() pressed: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {}
}
